var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.938 3.12942C14.6119 3.12942 15.9815 4.49898 15.9815 6.17289C15.9815 7.84681 14.6119 9.21637 12.938 9.21637C11.2641 9.21637 9.89452 7.84681 9.89452 6.17289C9.89452 4.49898 11.2641 3.12942 12.938 3.12942ZM12.938 18.3468C17.0467 18.3468 21.7641 20.3099 22.0684 21.3903H3.80756C4.15756 20.2946 8.84452 18.3468 12.938 18.3468ZM12.938 0.0859375C9.57495 0.0859375 6.85104 2.80985 6.85104 6.17289C6.85104 9.53594 9.57495 12.2599 12.938 12.2599C16.301 12.2599 19.025 9.53594 19.025 6.17289C19.025 2.80985 16.301 0.0859375 12.938 0.0859375ZM12.938 15.3033C8.87495 15.3033 0.764084 17.3425 0.764084 21.3903V24.4338H25.1119V21.3903C25.1119 17.3425 17.001 15.3033 12.938 15.3033Z",
    fill: "#091F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.e09c92342c7f422fc1f8a4b90140ecdb.svg";
export { ForwardRef as ReactComponent };